// extracted by mini-css-extract-plugin
export default {"container":"topCompanies_container__FVsks","border":"topCompanies_border__8LTF3"};